/**
 * 应用内路径（含 Vue BASE_URL 前缀）
 * @param {string} path 以 / 开头
 */
export function resolveAppPath (path) {
  const base = process.env.BASE_URL || '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`
  const normalizedPath = String(path || '').replace(/^\//, '')
  return `${normalizedBase}${normalizedPath}`.replace(/([^:]\/)\/+/g, '$1')
}

/** 完整 URL（origin + app path） */
export function resolveAppUrl (path) {
  if (typeof window === 'undefined') return path
  return `${window.location.origin}${resolveAppPath(path)}`
}
